module.exports = __webpack_public_path__ + "static/humble-pie-031d3ade615425c55a89955d644a9d52.jpg";